import { Component} from '@angular/core';


import { HttpClient} from '@angular/common/http';
import { AuthService } from '../../_services';

@Component({
  selector: 'vts-reports',
  templateUrl: './crmReport.component.html', 
})

export class CrmReportComponent {
  constructor(private HttpClient : HttpClient,private auth : AuthService) { 
  }  
  ngOnInit() 
  { 
  
  }

}
 


// WEBPACK FOOTER //
// ./src/app/reports/crmReport/crmReport.component.ts